const brochure = {
  'brochure.jsonld.breadcrumb1': 'ホーム',
  'brochure.jsonld.breadcrumb2': 'お問い合わせ',
  'brochure.jsonld.breadcrumb3': '資料請求',
  'brochure.jsonld.orgName': '日本執事アカデミー',
  'brochure.jsonld.parentOrg': '一般社団法人全日本執事協会',
  'brochure.page.homeLink': 'ホーム',
  'brochure.page.contactLink': 'お問い合わせ',
  'brochure.page.currentPage': '資料請求',
  'brochure.page.lastUpdated': '最終更新: 2026年6月13日',
  'brochure.page.backToTop': 'ページの先頭へ戻る',

  'brochure.hero.homeLink': 'ホーム',
  'brochure.hero.contactLink': 'お問い合わせ',
  'brochure.hero.currentPage': '資料請求',
  'brochure.hero.title': '資料請求',
  'brochure.hero.titleEn': 'BROCHURE',
  'brochure.hero.lead': 'コース内容や料金をまとめた資料を、無料でPDFにてお送りします。執事養成学校のコース体系や、少人数制で学ぶ日本の執事学校の特長を、資料請求でご確認いただけます。',
  'brochure.hero.imgAlt': '資料を手にした執事がアカデミーの図書室で佇む様子',

  'brochure.contents.label': 'CONTENTS',
  'brochure.contents.title': '資料の内容',
  'brochure.contents.subtitleEn': 'What\'s Inside',
  'brochure.contents.lead': 'アカデミーへのご入学を検討される方に必要な情報を、わかりやすくまとめた資料です。日本の執事学校としての学びの全体像も、資料請求一式に含めています。',
  'brochure.contents.0.title': 'アカデミー概要',
  'brochure.contents.0.titleEn': 'Academy Overview',
  'brochure.contents.0.desc': '日本執事アカデミーの設立趣旨、教育理念、運営体制についてご紹介します。',
  'brochure.contents.1.title': '3コースの内容と料金',
  'brochure.contents.1.titleEn': 'Courses & Pricing',
  'brochure.contents.1.desc': 'エッセンシャル・アドバンス・マスターの各コースについて、学習内容と受講料の内訳を詳しく掲載しています。',
  'brochure.contents.2.title': 'カリキュラムと年間スケジュール',
  'brochure.contents.2.titleEn': 'Curriculum & Schedule',
  'brochure.contents.2.desc': '学びの全体像、日々の時間割、年間の開校予定を一覧でご確認いただけます。',
  'brochure.contents.3.title': '認定資格・修了証',
  'brochure.contents.3.titleEn': 'Certification',
  'brochure.contents.3.desc': '修了時に取得できる協会認定資格と、その活用方法についてまとめています。',
  'brochure.contents.4.title': '申込方法',
  'brochure.contents.4.titleEn': 'Application Process',
  'brochure.contents.4.desc': '応募資格から入学のお申込み手順まで、受講開始までの流れをわかりやすくご案内します。',
  'brochure.contents.notice': '資料は予告なく内容を更新する場合がございます。最新の情報は本ウェブサイトでもご確認いただけます。',

  'brochure.form.label': 'REQUEST FORM',
  'brochure.form.title': '資料請求フォーム',
  'brochure.form.subtitleEn': 'Brochure Request Form',
  'brochure.form.lead': '下記フォームよりお申し込みください。いただいた情報は資料のご送付にのみ使用します。',
  'brochure.form.required': '必須',
  'brochure.form.optional': '任意',
  'brochure.form.name': '氏名',
  'brochure.form.namePlaceholder': '例: 執事 太郎',
  'brochure.form.nameError': '氏名は必須です',
  'brochure.form.furigana': 'ふりがな',
  'brochure.form.furiganaPlaceholder': '例: しつじ たろう',
  'brochure.form.furiganaError': 'ふりがなは必須です',
  'brochure.form.email': 'メールアドレス',
  'brochure.form.emailPlaceholder': '例: taro@example.com',
  'brochure.form.emailError': 'メールアドレスは必須です',
  'brochure.form.emailInvalidError': '有効なメールアドレスを入力してください',
  'brochure.form.phone': '電話番号',
  'brochure.form.phonePlaceholder': '例: 090-1234-5678',
  'brochure.form.delivery': '送付方法',
  'brochure.form.delivery.pdf': 'PDF送付（メール）',
  'brochure.form.delivery.pdf.desc': 'ご入力いただいたメールアドレスに、資料のPDFを送付します。すぐにご覧いただけます。',
  'brochure.form.course': '興味のあるコース',
  'brochure.form.course.essential': 'エッセンシャルコース',
  'brochure.form.course.advanced': 'アドバンスコース',
  'brochure.form.course.master': 'マスターコース',
  'brochure.form.course.undecided': 'まだ決めていない',
  'brochure.form.privacy': 'プライバシーポリシー',
  'brochure.form.privacyAgree': 'に同意する',
  'brochure.form.privacyError': 'プライバシーポリシーへの同意が必要です',
  'brochure.form.noHardSell': '資料請求は無料です。ご希望のない方への過度なご連絡はいたしません。安心してお申込みください。',
  'brochure.form.submit': '資料を請求する',

  'brochure.post.label': 'AFTER SUBMISSION',
  'brochure.post.title': '送信後のご案内',
  'brochure.post.subtitleEn': 'What Happens Next',
  'brochure.post.lead': 'ご送信後、ご入力いただいたメールアドレスに資料のPDFをお送りします。',
  'brochure.post.step1.title': '自動返信メールをお送りします',
  'brochure.post.step1.desc': 'ご入力いただいたメールアドレスに、受付確認の自動返信メールをお送りします。',
  'brochure.post.step2.title': '資料をお届けします',
  'brochure.post.step2.desc': '1営業日以内にPDFをお送りします。',
  'brochure.post.step3.title': '個別のご相談も承ります',
  'brochure.post.step3.desc': 'ご希望の方には、個別相談のご案内もしております。お気軽にお申し付けください。',

  'brochure.alt.label': 'ALTERNATIVE',
  'brochure.alt.title': 'お電話・メールでもご請求いただけます',
  'brochure.alt.subtitleEn': 'Other Request Methods',
  'brochure.alt.lead': 'フォームのほか、お電話やメールでもご請求いただけます。',
  'brochure.alt.phoneHours': '受付 平日10:00〜17:00',
  'brochure.alt.emailReply': '返信目安: 1営業日以内',

  'brochure.cta.label': 'NEXT STEP',
  'brochure.cta.title': '資料請求だけでなく、個別相談も無料です',
  'brochure.cta.subtitleEn': 'Take the Next Step',
  'brochure.cta.lead': '資料をご覧になった後は、無料の個別相談でお気軽にご質問ください。',
  'brochure.cta.btn': '個別相談を予約する',

  'brochure.pdfDl.button': '資料請求後にダウンロード案内をメールでお送りします',

  'brochure.faq.label': 'FAQ',
  'brochure.faq.title': 'よくあるご質問',
  'brochure.faq.subtitleEn': 'Frequently Asked Questions',
  'brochure.faq.0.q': '資料は無料ですか?',
  'brochure.faq.0.a': 'はい。無料でPDFにてお送りします。',
  'brochure.faq.1.q': 'どんな資料が届きますか?',
  'brochure.faq.1.a': 'アカデミー概要、3コースの内容と料金、カリキュラム、認定資格、年間スケジュール、申込方法などをまとめた資料です。',
  'brochure.faq.2.q': 'しつこい勧誘はありますか?',
  'brochure.faq.2.a': 'ご希望のない方への過度なご連絡はいたしません。ご相談を希望される場合のみ、担当者よりご案内します。',

  'brochure.related.label': 'LEARN MORE',
  'brochure.related.title': '関連ページ',
  'brochure.related.subtitleEn': 'Explore Further',
  'brochure.related.viewMore': '詳しく見る',
  'brochure.related.0.title': '個別相談予約',
  'brochure.related.0.description': '無料・オンライン可の相談',
  'brochure.related.1.title': 'コース一覧・比較',
  'brochure.related.1.description': '3コースの違いを一覧で確認',
  'brochure.related.2.title': '体験講座',
  'brochure.related.2.description': '1日で執事の所作を体験',
  'brochure.related.3.title': 'お問い合わせ',
  'brochure.related.3.description': 'ご質問・ご相談の窓口',
};

export default brochure;
